var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commodity-wrapper"},[_c('info-goods-swipe'),_c('info-item'),_c('info-buy'),_c('recommend-item'),_c('div',{staticStyle:{"height":"0.25rem","background-color":"#F0F2F5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }